import { BannerCard } from '@design-system';
import React, { FC } from 'react';

import { TrackEventEntrypoint } from '../../../utils/analytics';
import { useBannerLabels } from '../../BannerV3/BannerEvent';

interface Props {
  analytics: Analytics;
  artistName: string;
  event: EventType;
}

export const ArtistEventTile: FC<Props> = ({
  analytics,
  artistName,
  event,
}) => {
  const { endTime, image, startTime } = event.link.story.content;
  const { overrideCategory, overrideHeadline, overrideImage, overrideLabel } =
    event;
  const labels = useBannerLabels(startTime, endTime, overrideLabel);

  return (
    <BannerCard
      as="a"
      aspectRatioClassName="aspect-[4/3]"
      description={overrideCategory || event.link.story.content.subtitle}
      href={`/${event.link.story.full_slug}`}
      image={overrideImage || image}
      onClick={() => {
        TrackEventEntrypoint(analytics.page, {
          ...analytics,
          artistName,
        });
      }}
      pillIsActive={labels[0].active || false}
      pillLabel={labels[0].text || undefined}
      title={overrideHeadline || event.link.story.content.title}
      variant="image"
    />
  );
};
